var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUnlockSpend = function SvgUnlockSpend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.5c0-2.9-2.4-5.3-5.3-5.3h-.1c-2.9.1-5.2 2.4-5.2 5.4v2.8h1.9V6.6c0-1.9 1.6-3.5 3.5-3.5 1.9.1 3.4 1.6 3.4 3.5.1.5.6.9 1.1.8.4 0 .7-.4.7-.9z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 9.3H12v13.5H4.4c-.9 0-1.6-.7-1.6-1.6V10.9c0-.9.7-1.6 1.6-1.6z",
    fill: "#FDD835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.3h7.6c.9 0 1.6.7 1.6 1.6v10.3c0 .9-.7 1.6-1.6 1.6H12V9.3z",
    fill: "#FBC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 15c0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6 0 .6.3 1.1.8 1.4l-.5 2.3h2.7l-.5-2.3c.4-.3.7-.8.7-1.4z",
    fill: "#F9A825"
  })));
};
export default SvgUnlockSpend;